"use client";
import { Hero } from "./hero";
import { ExecutiveSummary } from "./executive-summary";
import { Problem } from "./problem";
import { Solution } from "./solution";
import { Details } from "./details";
import { Benefits } from "./benefits";
import { Usps } from "./usps";
import { WhoItsFor } from "./who-its-for";
import { FAQ } from "./faq";
import { Cta } from "./cta";

export function DeploymentPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-purple">
        <ExecutiveSummary />
      </div>
      <Problem />
      <div className="bg-aurora-crimson">
        <Solution />
      </div>
      <Details />
      <div className="bg-aurora-emerald">
        <Benefits />
      </div>
      <Usps />
      <div className="bg-aurora-denim">
        <WhoItsFor />
      </div>
      <FAQ />
      <Cta />
    </>
  );
}
